import creditEvaluationsApi from '@/api/now/creditEvaluationsApi'

let loanService = {
  getIsCreditEvaluated() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await creditEvaluationsApi.getCurrentCreditEvaluation()
        resolve(data != null && data.is_qualified === true && data.is_evaluation_expired !== true)
      } catch (e) {
        reject(e)
      }
    })
  },
  getIsEvaluationExpired() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await creditEvaluationsApi.getCurrentCreditEvaluation()
        resolve(data != null && data.is_evaluation_expired === true)
      } catch (e) {
        reject(e)
      }
    })
  },
  postCreditEvaluations() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await creditEvaluationsApi.postCreditEvaluations()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postCreditEvaluate(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await creditEvaluationsApi.postCreditEvaluate(id)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  }
}
export default loanService
